module.exports = __webpack_public_path__ + "common/close-gray-78e9ea58f0d22ac2ae1b9f09d3468617.svg";